import { Serializer } from '@teem/generic/serializer';
import { Resource } from '@teem/generic/resource';
import * as moment from 'moment';

export class ExpenseSerializer implements Serializer {
	fromJson(json: any): Expense {
		let expense = new Expense(json);
		return expense;
	}

	toJson(expense: Expense): any {
		return expense;
	}
}

export class Expense implements Resource {
	public id: number;
	public uuid: string = null;
	public description: string;
	public expense_date: string = moment().format('DD/MM/YYYY');
	public expense_type: string;
	public expense_category: string;
	public invoice_id: number = null;
	public cost: number;
	public payment_type: string = "monthly";
	public receipt_number: string;
	public vat_include: number = 0;
	public invoice_title: string;
	public total_months: number;
	public currency: number;
	public has_child_expense: number;
	public parent_expense_id: number;
	
	public vendor_name: string;
	public vat_number: string;
	public vat_percentage: number;
	public taxable_amount: number;
	public net_vat_amount_percent: number = 0;

	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);

			// if(input.expense_date)
			// this.expense_date = moment(input.expense_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
		}
	}
}
